import styled from "@emotion/styled";
import { Button } from "react-bootstrap";
import { IStyledComponentProps } from "../../theme/theme.types";

const CESoarButton = styled(Button)<IStyledComponentProps>`
  &.ce-soar-button {
    border-radius: 0;
    font-family: ${(props) => props.theme?.fontFamilies?.semiBold};
    padding: 12px 20px;
    text-align: center;
    transition: all 300ms ease-in-out;
    &.block {
      width: 100%;
    }

    &.btn-primary {
      background-color: ${(props) => props.theme.colors?.essential.buttonGreen};
      border: 1px solid ${(props) => props.theme.colors?.essential.buttonGreen};
      color: ${(props) => props.theme.colors?.essential.white};
      &:hover {
        &:not(:disabled) {
          background-color: ${(props) => props.theme.colors?.cta.primary};
          border: 1px solid ${(props) => props.theme.colors?.cta.primary};
          &:not(.no-scale) {
            transform: scale(1.05);
          }
        }
      }
    }

    &.btn-secondary {
      background-color: ${(props) => props.theme.colors?.essential.white};
      border: 1px solid ${(props) => props.theme.colors?.essential.buttonGreen};
      color: ${(props) => props.theme.colors?.essential.buttonGreen};
      &:hover {
        &:not(:disabled) {
          border: 1px solid ${(props) => props.theme.colors?.cta.primary};
          color: ${(props) => props.theme.colors?.cta.primary};
          &:not(.no-scale) {
            transform: scale(1.05);
          }
        }
      }
    }
  }
`;

const ButtonContainer = styled.div<IStyledComponentProps>`
  &.button-container {
    display: inline-block;
    text-align: center;
    padding: 12px;
    width: 100%;
  }
`;

const LinkButton = styled.button<IStyledComponentProps>`
  &.link-button {
    background-color: transparent;
    appearance: none;
    border: 0 none;
    cursor: pointer;
    font-family: ${(props) => props.theme?.fontFamilies?.semiBold};
    &,
    &:hover,
    &:focus,
    &:active {
      color: ${({ theme }) => theme.colors?.brand?.primary};
    }
  }
`;

export default {
  CESoarButton,
  LinkButton,
  ButtonContainer,
};
